import React, { forwardRef } from 'react'
import { View } from 'react-native'

import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type PrimaryIconButtonProps = Omit<BaseButtonProps, 'rightIcon' | 'loading' | 'buttonType' | 'selected'>

export const PrimaryIconButton = forwardRef<React.ElementRef<typeof View>, PrimaryIconButtonProps>((props, ref) => {
  return <BaseButton ref={ref} {...props} buttonType={ButtonType.PRIMARY_ICON} />
})

export default PrimaryIconButton
